/**
 * ecom-sticky-sync.js
 * Keeps the PageFly / ecom sticky-ATC variant <select> in sync with the
 * main product form. The sticky ATC has its own independent <select name="id">
 * that does not automatically follow the main Shopify variant picker.
 * product-info.js dispatches a `change` event on input[name="id"] after every
 * async variant fetch — we listen for that and mirror the new value.
 */
(function () {
  'use strict';

  function init() {
    var productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    var sectionId = productInfo.dataset.section;
    var mainProductForm = document.getElementById('product-form-' + sectionId);
    if (!mainProductForm) return;

    mainProductForm.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') {
        var newVariantId = e.target.value;
        var stickySelect = document.querySelector('.ecom-sticky__atc select[name="id"]');
        if (stickySelect && stickySelect.value !== newVariantId) {
          stickySelect.value = newVariantId;
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
